<div class="grid p-fluid">
  <form [formGroup]="resultForm" class="col-12 lg:col-12 md:col-12 form-group" novalidate>
    <div class="p-fluid p-formgrid grid">
        <div class="p-field col-12 md:col-6 margt-5">
            <span class="p-float-label size_cent">
                <div>{{'User_1' | translate}} *</div>
                <p-dropdown
                      formControlName="name"
                      [style]="{ width: '100%' }"
                      [options]="delegateBase"
                      filter="true"
                      placeholder="{{'Sel_User' | translate}}"
                ></p-dropdown>
            </span>
            <div class="margt-10"> {{'Desc' | translate}}</div>
            <textarea formControlName="desc" rows="5" cols="57" pInputTextarea></textarea>
        </div>
        <div class="p-field col-12 md:col-6 margt-5">
            <div class="grid">
                <div class="col-4 word-break-all margauto">{{'Mgt_User' | translate}}</div>
                <div class="col-6 align-left margt-5">
                    <p-inputSwitch formControlName="mgtUser"></p-inputSwitch>
                </div>
                <div class="col-4 word-break-all margauto">{{'Mgt_Grp' | translate}}</div>
                <div class="col-6 align-left margt-5">
                    <p-inputSwitch formControlName="mgtGrp"></p-inputSwitch>
                </div>
                <div class="col-4 word-break-all margauto">{{'Mgt_Bsk' | translate}}</div>
                <div class="col-6 align-left margt-5">
                    <p-inputSwitch formControlName="mgtBsk"></p-inputSwitch>
                </div>
                <div class="col-4 word-break-all margauto">{{'Mgt_Ged' | translate}}</div>
                <div class="col-6 align-left margt-5">
                    <p-inputSwitch formControlName="mgtGed"></p-inputSwitch>
                </div>
                <div class="col-4 word-break-all margauto">{{'Mgt_Dlgt' | translate}}</div>
                <div class="col-6 align-left margt-5">
                    <p-inputSwitch formControlName="mgtDlgt"></p-inputSwitch>
                </div>
            </div>
        </div>
    </div>
  </form>
</div>

<div class="foo-ter col-12 lg:col-12 md:col-12 align-right">
  @if (resultForm.controls['id'].value) {
    <button
      (click)="deleteItem()"
      class="p-button-danger p-button p-component p-button-text-only blockBottom margin"
      >
      {{'Delete' | translate}}
    </button>
  }
  <button
    (click)="cancel()"
    class="p-button-primary p-button-outlined p-button p-component p-button-text-only btn-square margin"
    >
    {{'Cancel' | translate}}
  </button>
  <button
    (click)="validate()"
    type="button"
    class="p-button p-component p-button-text-only btn-square margin"
    >
    {{'Valid' | translate}}
  </button>
</div>
